document.querySelectorAll('.PhotoSliderInfoItem').forEach((el) => {
    tns({
        container: el.querySelector('.PhotoSliderInfoItem__slider'),
        items: 1,
        mouseDrag: true,
        controls: false,
        loop: true,
    }).then((slider) => {
        el.querySelector('button[data-next]').addEventListener('click', () => slider.goTo('next'));
        el.querySelector('button[data-prev]').addEventListener('click', () => slider.goTo('prev'));
    });

})
